import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button, Modal } from '@storable/canaveral-components';
import useCurrentUser from '../../hooks/useCurrentUser';
import { MANAGE } from '../../../modules/authorization/actions';
import { FACILITY_PAGES, NON_FACILITY_PAGES } from '../../../modules/authorization/subjects';
import { EDIT } from '../MediaGallery/constants';
import styles from './styles.scss';

const propTypes = {
  softDeleteMedium: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  setBanners: PropTypes.func.isRequired,
  setSelectedMedium: PropTypes.func.isRequired,
  data: PropTypes.shape({
    mediumToggleTrash: PropTypes.shape({
      medium: PropTypes.object,
      userErrors: PropTypes.array,
    }).isRequired,
  }),
  updateFilter: PropTypes.func.isRequired,
  filter: PropTypes.string.isRequired,
};

const defaultProps = {
  loading: undefined,
  data: undefined,
};

const MediaGalleryActions = ({
  softDeleteMedium,
  loading,
  setBanners,
  setSelectedMedium,
  data,
  updateFilter,
  filter,
}) => {
  const [showTrashModal, setShowTrashModal] = useState(false);

  useEffect(() => {
    if (data) {
      if (data.mediumToggleTrash.userErrors.length) {
        setBanners({ errors: ['There was a problem moving your image to the trash.  Please try again.'] });
        setShowTrashModal(false);
      } else {
        setSelectedMedium(undefined);
        setBanners({ success: 'Success!  Your image has been moved to the trash.' });
      }
    }
  }, [data]);

  const currentUser = useCurrentUser();
  const unauthorized = currentUser.cannot(MANAGE, FACILITY_PAGES, NON_FACILITY_PAGES);

  const toggleShowTrashModal = () => setShowTrashModal(!showTrashModal);

  const onClickEdit = () => {
    updateFilter(EDIT);
    setBanners({ info: 'Editing the title and alt text here will also update it everywhere the image is used.' });
  };

  return (
    <>
      <Button
        context="bare"
        icon="edit"
        className={cx([styles.button, { [styles.highlight]: filter === EDIT }])}
        onClick={onClickEdit}
        disabled={unauthorized}
      >
        Edit
      </Button>
      <Button
        context="bare"
        icon="trash"
        className={styles.button}
        onClick={toggleShowTrashModal}
        disabled={unauthorized}
      >
        Move to Trash
      </Button>
      <Modal
        show={showTrashModal}
        onDismiss={toggleShowTrashModal}
      >
        <Modal.Header>
          <Modal.Title id="mediaGalleryActions">
            Delete from Media Gallery
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          This image could be placed on multiple pages, so deleting it could create broken
          image links on your website.  Are you sure you want to delete this image?
        </Modal.Body>
        <Modal.Footer>
          <Button context="neutral" onClick={toggleShowTrashModal} disabled={loading}>
            Cancel
          </Button>
          <Button context="danger" onClick={softDeleteMedium} disabled={loading}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

MediaGalleryActions.propTypes = propTypes;
MediaGalleryActions.defaultProps = defaultProps;

export default MediaGalleryActions;
